<div class="beneficios" data-testid="beneficios">
  <vivest-card class="beneficios__menu-card" variant="default" full-width>
    <nav class="beneficios__menu" aria-labelledby="beneficios-menu-titulo">
      <div class="beneficios__menu-cabecalho">
        <h2 id="beneficios-menu-titulo" class="beneficios__menu-titulo">Benefícios</h2>
        <p class="beneficios__menu-descricao">Parametrizações do plano</p>
      </div>
      <ul class="beneficios__secoes">
        @for (secao of secoes; track secao.id) {
          <li>
            <button
              type="button"
              class="beneficios__secao"
              [class.beneficios__secao--ativa]="secaoAtiva() === secao.id"
              [attr.aria-current]="secaoAtiva() === secao.id ? 'page' : null"
              [disabled]="!secaoDisponivel(secao.id)"
              [attr.title]="secaoDisponivel(secao.id) ? null : 'Disponível em breve'"
              [attr.data-testid]="'beneficios-secao-' + secao.id"
              (click)="selecionarSecao(secao.id)"
            >
              <vivest-icon [name]="secao.icone" source="feather" aria-hidden="true"></vivest-icon>
              <span class="beneficios__secao-texto">
                <span class="beneficios__secao-rotulo">{{ secao.rotulo }}</span>
                @if (!secaoDisponivel(secao.id)) {
                  <span class="beneficios__em-breve">Em breve</span>
                }
              </span>
            </button>
          </li>
        }
      </ul>
    </nav>
  </vivest-card>

  <vivest-card class="beneficios__conteudo" variant="default" full-width>
    <!-- Recriada a cada visita: sempre mostra as regras salvas. -->
    @if (secaoAtiva() === 'visao-geral') {
      <app-beneficios-visao-geral
        [planoId]="planoId()"
        [nomePlano]="nomePlano()"
        (editar)="editarBeneficio($event)"
      />
    }
    @if (elegibilidadeAberta()) {
      <div [hidden]="secaoAtiva() !== 'elegibilidade'">
        <app-beneficios-elegibilidade
          [planoId]="planoId()"
          [nomePlano]="nomePlano()"
          [beneficioInicial]="beneficioInicial()"
        />
      </div>
    }
    @if (opcoesRendaAberta()) {
      <div [hidden]="secaoAtiva() !== 'opcoes-renda'">
        <app-beneficios-opcoes-renda [planoId]="planoId()" [nomePlano]="nomePlano()" />
      </div>
    }
    @if (antecipacaoAberta()) {
      <div [hidden]="secaoAtiva() !== 'antecipacao'">
        <app-beneficios-antecipacao [planoId]="planoId()" [nomePlano]="nomePlano()" />
      </div>
    }
    @if (rentabilidadeAberta()) {
      <div [hidden]="secaoAtiva() !== 'rentabilidade'">
        <app-beneficios-rentabilidade [planoId]="planoId()" [nomePlano]="nomePlano()" />
      </div>
    }
    @if (valorMinimoSaldoAberta()) {
      <div [hidden]="secaoAtiva() !== 'valor-minimo-saldo'">
        <app-beneficios-valor-minimo-saldo [planoId]="planoId()" [nomePlano]="nomePlano()" />
      </div>
    }
  </vivest-card>
</div>
